import axios from 'axios';
import sesionService from '@/services/SesionService';

export default {
	async getAllChildren() {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get('/child/all', HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async getAllForSelect(query, limit) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let params = { query, limit };
				params = Object.keys({ query, limit })
					.filter((key) => params[key])
					.map((key) => {
						return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
					})
					.join('&');
				params = params != '' ? '?' + params : params;
				let res = await axios.get(`/child/for-select${params}`, HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async getChild(id) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get(`/child/${id}`+"?view=web", HEADER);
				let { Data: data } = res.data;
				if (data.child.documents && data.child.documents.length) {
					data.child.documents = data.child.documents.sort((a, b) => {
						return (
							new Date(b.documentElement?.updatedAt) -
							new Date(a.documentElement?.updatedAt)
						);
					});
				}

				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async postChild(name, lastName, teams) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.post('/child', { name, lastName, teams }, HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async putChild(id, name, lastName, teams) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.put(`/child/${id}`, { name, lastName, teams }, HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async putDataChild(id, params) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.put('child/data/' + id, params, HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	},

	async putDocumentChild(id, params) {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.put('child/document/' + id, params, HEADER);
				let { Data: data } = res.data;
				return data;
			} catch (error) {
				console.log(error);
			}
		}
	}
};
